var PlayerModule = /** @class */ (function () {
    function PlayerModule() {
    }
    return PlayerModule;
}());
export { PlayerModule };
